<style>
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body" style="margin-top: -4%;">
            <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
                <div class="form-group card-with-shadow p-2 mt-3">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="10+2" class="label"> {{ $t("10+2") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('10+2')"
                                    v-model="inputs.ten_plus_two"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="inv_to_acc" class="label"> {{ $t("inv_to_acc") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('inv_to_acc')"
                                    v-model="inputs.inv_to_acc"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="freight" class="label"> {{ $t("freight") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('freight')"
                                    v-model="inputs.freight"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="insurance" class="label"> {{ $t("insurance") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('insurance')"
                                    v-model="inputs.insurance"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="arrival_notice" class="label"> {{ $t("arrival_notice") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('arrival_notice')"
                                    v-model="inputs.arrival_notice"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="surren_bl" class="label"> {{ $t("surren_bl") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('surren_bl')"
                                    v-model="inputs.surren_bl"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="broker" class="label"> {{ $t("broker") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('broker')"
                                    v-model="inputs.broker"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="trucker" class="label"> {{ $t("trucker") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('trucker')"
                                    v-model="inputs.trucker"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="pre_advice" class="label"> {{ $t("pre_advice") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('pre_advice')"
                                    v-model="inputs.pre_advice"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="del_order" class="label"> {{ $t("del_order") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('del_order')"
                                    v-model="inputs.del_order"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="custom" class="label"> {{ $t("custom") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('custom')"
                                    v-model="inputs.custom"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="manifest" class="label"> {{ $t("manifest") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('manifest')"
                                    v-model="inputs.manifest"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="fda_release" class="label"> {{ $t("fda_release") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('fda_release')"
                                    v-model="inputs.fda_release"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="x_ray" class="label"> {{ $t("x_ray") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('x_ray')"
                                    v-model="inputs.x_ray"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="cet" class="label"> {{ $t("cet") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('cet')"
                                    v-model="inputs.cet"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                         <div class="col-md-3">
                            <div class="form-group">
                                <label for="cet" class="label"> {{ $t("cet") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('cet')"
                                    v-model="inputs.cet"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="tailgate" class="label"> {{ $t("tailgate") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('tailgate')"
                                    v-model="inputs.tailgate"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="intense_exam" class="label"> {{ $t("intense_exam") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('intense_exam')"
                                    v-model="inputs.intense_exam"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="other_exam" class="label"> {{ $t("other_exam") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('other_exam')"
                                    v-model="inputs.other_exam"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="pickup_from_port" class="label"> {{ $t("pickup_from_port") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('pickup_from_port')"
                                    v-model="inputs.pickup_from_port"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="return_empty" class="label"> {{ $t("return_empty") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('return_empty')"
                                    v-model="inputs.return_empty"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="mt-5 col-md-3 action-buttons">
                        <button type="button" class="btn btn-primary mr-2  w-100" 
                            @click="save"
                            :disabled="isDisabled"
                        >
                            {{ $t('save') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';

export default {
    name: "add_contractDetail_form",
    mixins: [FormMixin],
    data() {
        return {
            isDisabled : true,
            inputs: {
                ten_plus_two : null,
                inv_to_acc : null,
                freight : null,
                insurance : null,
                arrival_notice : null,
                surren_bl : null,
                broker : null,
                trucker : null,
                pre_advice : null,
                del_order : null,
                custom : null,
                manifest : null,
                fda_release : null,
                x_ray : null,
                cet : null,
                tailgate : null,
                intense_exam : null,
                other_exam : null,
                pickup_from_port : null,
                return_empty : null,
            },
            preloader : false,
            contractId : null,
        }  
    },
    methods: {
        async save(){
            this.preloader = true;
            try {
                const { data } = await axios.post(
                    `/api/subcontract/save_schedule/${this.contractId}`,
                    this.inputs
                );
                this.$toastr.s(data.message || this.$t('saved_successfully'));
            } catch (e) {
                const errors = e.response?.data?.errors;
                const msg = errors
                    ? Object.values(errors)[0][0]
                    : (e.response?.data?.message || this.$t('something_went_wrong'));
                this.$toastr.e(msg);
            } finally {
                this.preloader = false;
            }
        },

        async loadData() {
            try {
                this.preloader = true;
                const { data } = await axios.get(
                    `/api/subcontract/get_schedule/${this.contractId}`
                );
                if (data) {
                    Object.keys(this.inputs).forEach(key => {
                        this.inputs[key] = data[key] ?? null;
                    });
                }
                this.preloader = false;
            } catch (e) {
                console.log(`errro ${e}`);
                this.preloader = false;
            }
        },

    },

    watch : {
        inputs : {
            deep : true,
            handler(newVal){

            }
        }
    },

    props: {
        props: { type: Object, default: () => ({}) }
    },

    mounted() {    
        this.contractId = this.props?.id ?? this.$route?.params?.id ?? null;
        if (!this.contractId) {
            console.warn('subcontract id not found', this.props, this.$route?.params);
            return;
        }
        this.loadData();
        let isLogisticCoordinator = false;
        const roles = user.roles;
        roles.forEach( rol => {
            if (rol.name === 'Logistics Coordinator') {
                isLogisticCoordinator = true;
            }
        });
        if (isLogisticCoordinator) {
            this.isDisabled = false;
        }
    },
}
</script>
